module.exports = __webpack_public_path__ + "static/media/game.19348698.png";